var url = 'https://polyfill.io/v3/polyfill.min.js';
var detections = [["Promise","Promise"in self
],
["URL",(function(e){"use strict"
try{var a=new e.URL("http://example.com")
if("href"in a&&"searchParams"in a){var r=new URL("http://example.com")
if(r.search="a=1&b=2","http://example.com/?a=1&b=2"===r.href&&(r.search="","http://example.com/"===r.href)){var t=new e.URLSearchParams("a=1"),c=new e.URLSearchParams(t)
if("a=1"===String(c))return!0}}return!1}catch(h){return!1}})(self)
],
["WeakSet",(function(e){try{if(Object.prototype.hasOwnProperty.call(e,"WeakSet")&&0===e.WeakSet.length){var t={},r=new e.WeakSet([t])
return r.has(t)&&!1===r["delete"](0)}return!1}catch(a){return!1}})(self)
],
["Array.prototype.includes","includes"in Array.prototype
],
["CustomEvent","CustomEvent"in self&&("function"==typeof self.CustomEvent||self.CustomEvent.toString().indexOf("CustomEventConstructor")>-1)
],
["Object.entries","entries"in Object
],
["Object.values","values"in Object
]]

function loadScript(src, done) {
	var script = document.createElement('script');
	script.src = src;
	script.onload = done;
	script.onerror = function() {
		done(new Error('Failed to load script ' + src));
	};
	document.head.appendChild(script);
}

function getMissing()
{
    var polyfill = [];
    for (var i = 0; i < detections.length; i++) {
        if (! detections[i][1]) {
            polyfill.push(detections[i][0]);
        }
    }

    return polyfill;
}

function loadPolyfills(loadedCallback)
{
    var polyfills = getMissing();
    if (! polyfills.length) {
        return loadedCallback();
    }

    loadScript(url + '?features=' + polyfills.join(',') + '&flags=always', loadedCallback);
}

export default loadPolyfills;
